import { z } from 'zod';
import { AUTO_OPEN_URL_KEY } from './integrationListConstant';

export const SettingAccountIntegrationListRouteParams = z
    .object({
        name: z.string(),
        [AUTO_OPEN_URL_KEY]: z.optional(z.boolean({ coerce: true })),
    })
    .partial();
